import Vue from "vue";
import VueI18n from "vue-i18n";

import de from "../i18n/de.json";
import en from "../i18n/en.json";
Vue.use(VueI18n);

export const i18n = new VueI18n({
         locale:
           window.location.pathname.startsWith("/en") ||
           window.location.pathname.startsWith("/es")
             ? "en"
             : "de",
         messages: {
           de: {
             ...de,
           },
           en: {
             ...en,
           },
         },
       });
